import httpClient from "@/services";
import { API_ENDPOINTS } from "./endpoints";
import type { IMagicLinkPayload } from "@/hooks/use-magic-link";
import type { IUserInfo } from "@/hooks/use-user-info";
import ScreenRouteNames from "@/constants/screen-route-names";

const magicLinkService = async (userInfo: IUserInfo) => {
  const payload: IMagicLinkPayload = {
    memberId: userInfo?.memberId || "",
    route: ScreenRouteNames.OLD_COST_ESTIMATOR.path,
    groupId: userInfo?.groupId || "",
    divisionId: userInfo?.divisionId || "",
    source: "ZCONNECT",
    careTeamName: userInfo?.username || "",
  };

  // console.log("url payload >>>", API_ENDPOINTS.MAGIC_LINK, payload);
  const config = {
    headers: {
      "Accept-Version": "1.0",
      // "access-control-allow-origin": "https://zconnect-uat.zakipointhealth.com",
      "Content-Type": "application/json",
    },
  };

  return httpClient
    .post(API_ENDPOINTS.MAGIC_LINK, payload, config)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.error("Error fetching the magic link:", err);
      return null;
    });
};

export default magicLinkService;
